import * as _ from "lodash";
import entityBase from "entityBase";

export class MeterReadingContractDetailProducts extends entityBase {
  product_id: string;
  serial_id: string;
  model_id: string;
  iot: string;
  last_connection: Date;
  visiting_address: string;
  delivery_address: string;
  product_location: string;
  product_meter_plan: string;
  product_meter_plan_detail: string;
  contract_coverage_start_end: string;
  is_expired_contract: boolean;
  product_background_color: string;

  constructor(item, meter_plans) {
    super();
    this.product_id = item?.product_id;
    this.serial_id = item.serial_id;
    this.model_id = item.model_id;

    if (item.iot_device && item.iot_device.c_iot_device_ext) {
      this.iot = item.iot_device.c_iot_device_ext.ext_active == "" ? "N" : item.iot_device.c_iot_device_ext.ext_active;
      if (item.iot_device.c_iot_device_ext.ext_last_connection_dttm)
        this.last_connection = this.formatJSONDate(item.iot_device.c_iot_device_ext.ext_last_connection_dttm);
    }

    if (item.product && item.product.c_product_place_rel) {
      if (Array.isArray(item.product.c_product_place_rel)) {
        _.each(item.product.c_product_place_rel, (placeRel) => {
          let final_address = "";
          final_address = placeRel["place"]["name"];

          if (
            placeRel["place"] &&
            placeRel["place"]["place_address"] &&
            placeRel["place"]["place_address"]["address"]
          ) {
            let addressDetails = placeRel["place"]["place_address"]["address"];
            if (addressDetails["address"]) final_address += " " + addressDetails["address"];
            if (addressDetails["second_address"]) final_address += " " + addressDetails["second_address"];
            if (addressDetails["third_address"]) final_address += " " + addressDetails["third_address"];
            if (addressDetails["fourth_address"]) final_address += " " + addressDetails["fourth_address"];
            if (addressDetails["city"]) final_address += " " + addressDetails["city"];
            if (addressDetails["zippost"]) final_address += " " + addressDetails["zippost"];
            if (addressDetails["country"]) final_address += " " + addressDetails["country"];
          }

          if (placeRel["rel_type"] == "DELIVERY") {
            this.delivery_address = final_address.trim();
          } else if (placeRel["rel_type"] == "VISITING") {
            this.visiting_address = final_address.trim();
          }
        });
      } else {
        let final_address = "";
        final_address = item.product.c_product_place_rel.place.name;

        if (
          item.product.c_product_place_rel.place &&
          item.product.c_product_place_rel.place.place_address &&
          item.product.c_product_place_rel.place.place_address.address
        ) {
          let addressDetails = item.product.c_product_place_rel.place.place_address.address;
          if (addressDetails["address"]) final_address += " " + addressDetails["address"];
          if (addressDetails["second_address"]) final_address += " " + addressDetails["second_address"];
          if (addressDetails["third_address"]) final_address += " " + addressDetails["third_address"];
          if (addressDetails["fourth_address"]) final_address += " " + addressDetails["fourth_address"];
          if (addressDetails["city"]) final_address += " " + addressDetails["city"];
          if (addressDetails["zippost"]) final_address += " " + addressDetails["zippost"];
          if (addressDetails["country"]) final_address += " " + addressDetails["country"];
        }

        if (item.product.c_product_place_rel.rel_type == "DELIVERY") {
          this.delivery_address = final_address.trim();
        } else if (item.product.c_product_place_rel.rel_type == "VISITING") {
          this.visiting_address = final_address.trim();
        }
      }
    }

    if (item.product) {
      this.product_location = item.product.user_def1;
    }

    this.product_meter_plan = "";
    this.product_meter_plan_detail = "";
    if (item.contr_product_meter_plan) {
      if (Array.isArray(item.contr_product_meter_plan)) {
        _.each(item.contr_product_meter_plan, (itm) => {
          let found_meter_plan;
          if (Array.isArray(meter_plans)) {
            found_meter_plan = _.find(meter_plans, (mp) => {
              return mp["meter_plan_sequence"] == itm["meter_plan_sequence"];
            });
          } else {
            found_meter_plan = meter_plans;
          }
          if (found_meter_plan) {
            this.product_meter_plan += "<br>" + itm["meter_plan_sequence"];
            this.product_meter_plan_detail +=
              "<br>" +
              itm["meter_plan_sequence"] +
              (found_meter_plan["user_def2"] ? " - " + found_meter_plan["user_def2"] : "");
          }
        });
        this.product_meter_plan = this.product_meter_plan.substring(4);
        this.product_meter_plan_detail = this.product_meter_plan_detail.substring(4);
      } else {
        let found_meter_plan;
        if (Array.isArray(meter_plans)) {
          found_meter_plan = _.find(meter_plans, (mp) => {
            return mp["meter_plan_sequence"] == item.contr_product_meter_plan.meter_plan_sequence;
          });
        } else {
          found_meter_plan = meter_plans;
        }
        if (found_meter_plan) {
          this.product_meter_plan = item.contr_product_meter_plan.meter_plan_sequence;
          this.product_meter_plan_detail =
            item.contr_product_meter_plan.meter_plan_sequence +
            (found_meter_plan["user_def2"] ? " - " + found_meter_plan["user_def2"] : "");
        }
      }
    }

    const coverageEff_dt_string = this.formatStringDate(item?.coverage_eff_dt);
    const coverageEnd_dt_string = this.formatStringDate(item?.coverage_end_dt);

    this.contract_coverage_start_end = [coverageEff_dt_string, coverageEnd_dt_string].filter((s) => s).join(" - ");

    this.is_expired_contract = false;
    const today = new Date();
    if (item?.coverage_end_dt) {
      const coverageEndDate = new Date(item.coverage_end_dt);
      if (coverageEndDate < today) {
        this.is_expired_contract = true;
      }
    }

    this.product_background_color = this.is_expired_contract ? "#D3D3D3" : "transparent";
  }
}
